import { render, staticRenderFns } from "./CsuStepsPhase.vue?vue&type=template&id=52f3bec6&scoped=true&"
import script from "./CsuStepsPhase.vue?vue&type=script&lang=js&"
export * from "./CsuStepsPhase.vue?vue&type=script&lang=js&"
import style0 from "./CsuStepsPhase.vue?vue&type=style&index=0&id=52f3bec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3bec6",
  null
  
)

export default component.exports